const FAQs = [
  {
    titleText: 'When can I expect my UPCs to reflect in the reverse vending machines?',
    descriptionText: 'Please expect a 1-2 week delay from the date shown in "Review Status" column once the status has changed to "Completed"'
  },
  {
    titleText: 'Can I register only once, or will I have to keep coming back to this website every year?',
    descriptionText: 'Distributors and importers will need to return every year to add any new beverages they sold from the previous year to our beverage container registry.'
  },
  {
    titleText: 'Is there a way to be excluded from registering every year?',
    descriptionText: 'Yes, if a company joins as a patron of OBRC, one of the services we offer is taking care of their container registration. Please visit the OBRC Website for more information on the other services we offer.',
    links: [
      {
        url: 'https://www.obrc.com/Distributors',
        linkText: 'OBRC Website'
      }
    ]
  },
  {
    titleText: 'Who needs to register with OBRC?',
    descriptionText: 'Every distributor and importer of beverages sold in containers with an Oregon refund value, unless the distributor or importer is a patron of OBRC. Businesses that sell their product out of their taproom, tasting room, etc., or sell their beverages online without going through a distributor, are considered to be a dealer and therefore must register.'
  },
  {
    titleText: 'What is a "Distributor"?',
    descriptionText: '"Distributor" means every person who engages in the sale of beverages in beverage containers to a dealer in this state including any manufacturer who engages in such sales.'
  },
  {
    titleText: 'What is an "Importer"?',
    descriptionText: '"Importer" means any dealer or manufacturer who directly imports beverage containers into this state.'
  },
  {
    titleText: 'What is a "Dealer"?',
    descriptionText: '"Dealer" means every person in this state who engages in the sale of beverages in beverage containers to a consumer, or means a redemption center certified under ORS 459A.735.'
  },
  {
    titleText: 'What if I sell my beverages through a distributor or importer?',
    descriptionText: 'Companies that sell their beverages through a distributor or importer should notify their distributor or importer that they will need to register on our website. A company that uses a distributor or importer for some of their beverages but also self-distributes some beverages must also register with us and only report those self-distributed beverages.'
  },
  {
    titleText: 'What if I don’t register my beverage containers with OBRC?',
    descriptionText: 'It is now state law for beverage distributors and importers to register with us. The OLCC will investigate any business that do not register their beverage containers with OBRC and will assess a violation as appropriate.'
  },
  {
    titleText: 'Where can I go to learn more about the Oregon Bottle Bill and if my beverages are included/excluded?',
    descriptionText: 'Please visit OLCC\'s Website for more information.',
    links: [
      {
        url: 'https://www.oregon.gov/OLCC/pages/bottle_bill.aspx',
        linkText: 'OLCC Website'
      }
    ]
  },
  {
    titleText: 'I am having trouble registering, who can I contact for help?',
    descriptionText: 'Please email ORBottleBillRegistration@obrc.com with any questions you might have.',
    links: [
      {
        url: 'mailto:ORBottleBillRegistration@obrc.com?Subject=Question%20about%20the%20OBRC%20Container%20Registration%20Portal',
        linkText: 'Contact OBRC'
      }
    ]
  }
]

export default FAQs;